import { Field, Form, FormikProps, withFormik } from "formik";
import React, { FunctionComponent, memo } from "react";
import { Fieldset } from "../ui/form";
import { Button, ButtonVariant } from "../ui/button";
import { TranslatedString } from "@bigcommerce/checkout/locale";
import { string, number, object, date } from "yup";

export interface RpalFormValues {
    rpalEmail: string,
    rpalNumber: string
    fName: string
    lName: string
    dob: Date,
    expire: Date,
    city: string
}

export interface RpalFormProps {
    // rpalNumber: string,
    // onChangeRpalNumber(rpalNumber: string): void;
    onSubmit(values : RpalFormValues): void;
}

const RpalForm: FunctionComponent<RpalFormProps & FormikProps<RpalFormValues>> = (props) => {
    const {
        errors,
    } = props;

    return (
        <Form className="checkout-form"
            id="checkout-rpal"
        >
            <Fieldset>
                <div className="rpal-info">
                    <label>Legal First Name</label><br/>
                    <Field name="fName" className="form-input optimizedCheckout-form-input floating-input" />
                </div>
                <div className="rpal-info">
                    <label>Legal Last Name</label><br/>
                    <Field name="lName" className="form-input optimizedCheckout-form-input floating-input"  />
                </div>
                <div className="rpal-info">
                    <label>Date of Birth</label><br/>
                    <Field name="dob" type="date"  className="form-input optimizedCheckout-form-input floating-input" />
                </div>
                <div className="rpal-info">
                    <label>PAL Number (Please only enter the 8 digits before the decimal)</label><br/>
                    <Field name="rpalNumber" type="number" className="form-input optimizedCheckout-form-input floating-input"  />
                </div>
                <div className="rpal-info">
                    <label>PAL Email</label><br/>
                    <Field name="rpalEmail" type="email" className="form-input optimizedCheckout-form-input floating-input" />
                </div>
                <div className="rpal-info">
                    <label>PAL Expiration Date</label><br/>
                    <Field name="expire" type="date" className="form-input optimizedCheckout-form-input floating-input"  />
                </div>
                <div className="rpal-info">
                    <label>City of Birth</label><br/>
                    <Field name="city" className="form-input optimizedCheckout-form-input floating-input"  />
                </div>
                    {errors.rpalNumber}
                <div className="splitter">
                </div>
                <div>
                    <Button id="checkout-rpal-continue"
                        type="submit"
                        variant={ButtonVariant.Primary}>
                        <TranslatedString id="rpal.rpal_submit" />
                    </Button>
                </div>
                <style>{'input{ width: 200px; height:20px; font-size:16px } .splitter{ height: 40px }'}</style>
            </Fieldset>

        </Form>
    )
}

export default withFormik<RpalFormProps, RpalFormValues>({
    // I think this is for passing values into the form, so if the user had already entered their rpal info for example
    mapPropsToValues: () => ({
        rpalEmail: "",
        rpalNumber: "",
        fName: "",
        lName: "",
        dob: new Date(),
        expire: new Date(),
        city: "",
    }),
    handleSubmit: (values, { props: { onSubmit } }) => {
        onSubmit(values);
    },
    validationSchema: () => {
        const fName = string().required("First Name is Required")
        const lName = string().required("Last Name is Required")
        const dob = date().required("Date of Birth is Required")
        const expire = date().required("Expiration Date is Required")
        const city = string().required("City of Birth is Required")
        const rpalEmail = string().email().required("Email is Required")
        const rpalNumber = number().required("PAL Number is Required")

        const baseSchema = object({ fName, lName, dob, expire, city, rpalNumber, rpalEmail })

        return baseSchema;
    }
})(memo(RpalForm))